// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gfgd","col":"styles_col__Vd8No"};